import React, {FC, useContext} from 'react';
import {Button} from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {AuthContext} from "contexts";
import {Envs} from "enums/Envs";
import {settingsStore} from "stores";
import {supportService} from "services/supportService";

const MySwal = withReactContent(Swal)

interface Props {
    userId: string;
    userName: string;
    onReload: () => Promise<void>;
}

export const TestActionsButton: FC<Props> = ({userId, userName, onReload}) => {
    const {user: myUser, env} = useContext(AuthContext);


    const onClick = async () => {
        await MySwal.fire({
            title: "Выбор действия",
            icon: 'question',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "Отмена",
            html: <div className="d-flex flex-column">
                {settingsStore.customActions.map(v => <Button
                    key={v.action}
                    onClick={async () => {
                        if (!env) {
                            return
                        }

                        await supportService.execute(env, {userKey: userId, action: v.action})
                        MySwal.close();
                        onReload()
                    }}
                    variant="outline-dark"
                    className="my-1">
                    {v.description}
                </Button>)}
            </div>
        })
    }

    const canBeMadeTest = env && env.env === Envs.Test && myUser?.isSuperAdmin;


    if (!canBeMadeTest) {
        return null
    }

    return <Button variant={'outline-primary'} onClick={onClick}>Тестовые действия</Button>;
}